<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/foodfactory/topic_icon.svg" />
      <h1>Food Manufacturing</h1>
      <p>
        Hygienically manage the food manufacturing process to
        <br />
        safeguard against pests, viruses, and bacteria.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Canning </span>
        <span class="tag"> #Freezing </span>
        <span class="tag"> #Smoking </span>
        <span class="tag"> #Baking </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/foodfactory/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Food Manufacturing"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_pests.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
            <div class="title">
              <h3>Pest Control in Manufacturing Facilities</h3>
            </div>
            <p class="description">The infiltration of pests into the hygienically managed manufacturing facilities concerns me.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_assurance.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
            <div class="title">
              <h3>
                Concerns About
                <br />
                Food Safety
              </h3>
            </div>
            <p class="description">The safety of the manufactured food might cause anxiety among customers.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_response.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
            <div class="title">
              <h3>Management of Claims Due to Foreign Materials</h3>
            </div>
            <p class="description">Responding to and preventing potential foreign material contamination is a major concern.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>
              Tailor your factory management to meet increasingly stringent food hygiene standards.
              <br />
            </h4>
            <p>
              In response to elevated consumer expectations and stricter hygiene regulations, CESCO analyzes raw materials used in your manufacturing
              plant to identify and manage potential pests.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/foodfactory/border_content_01.png" alt="CESCO [BusinessSectors] Food Manufacturing" />
          </div>
          <div>
            <img src="@/assets/images/location/foodfactory/border_content_02.png" alt="CESCO [BusinessSectors] Food Manufacturing" />
          </div>
          <div class="border-content">
            <h4>
              Streamline the management of rigorous self-quality inspections and responses to Ministry of Food and Drug Safety (MFDS) inspections.
            </h4>
            <p>
              As an accredited self-quality inspection agency, CESCO simplifies the complex quality inspection process and provides solutions for
              resolving issues. We also support employee hygiene training and management.
            </p>
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Food Manufacturing" />

          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Food Manufacturing" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Food Manufacturing
      </h3>
      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_fly.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Flying Pest Control Solution</h3>
              </div>
              <p class="description">Managing stray pests such as flies, fruit flies, and sandflies</p>
            </div>

            <router-link to="/solution/service/fly"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Food Manufacturing" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_01.png'),
    products: [
      {
        posX: '47.125rem',
        posY: '28.995rem',
        mobilePosX: '62%',
        mobilePosY: '78%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_01.png'),
          name: 'CESCO\nSmart Indoor Rodent Control Equipment Viper',
          description: 'Hygienically captures rats that enter business premises and monitors their movement and habitation with smart technology.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_02.png'),
    products: [
      {
        posX: '47.6875rem',
        posY: '11.4325rem',
        mobilePosX: '63%',
        mobilePosY: '43%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_02.png'),
          name: 'CESCO\nIndoor Insect Light Phoenix',
          description: 'Effectively attracts and captures stray pests within business premises.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_03.png'),
    products: [
      {
        posX: '62rem',
        posY: '6.12rem',
        mobilePosX: '81%',
        mobilePosY: '20%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_03.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_04.png'),
    products: [
      {
        posX: '59.375rem',
        posY: '14.87rem',
        mobilePosX: '78%',
        mobilePosY: '46%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_04.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_05.png'),
    products: [
      {
        posX: '63.125rem',
        posY: '5.62rem',
        mobilePosX: '83%',
        mobilePosY: '20%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_05.png'),
          name: 'CESCO\nIndoor Insect Light Inceptor',
          description: 'This device controls stray pests entering business premises and also serves an aesthetic function with its compact design.'
        }
      }
    ]
  },

  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_06.png'),
    products: [
      {
        posX: '53.5625rem',
        posY: '4.87rem',
        mobilePosX: '71%',
        mobilePosY: '18%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_03.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_07.png'),
    products: [
      {
        posX: '28.375rem',
        posY: '18.745rem',
        mobilePosX: '38%',
        mobilePosY: '55%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_06.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_08.png'),
    products: [
      {
        posX: '51.25rem',
        posY: '23.5575rem',
        mobilePosX: '67.5%',
        mobilePosY: '71%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_07.png'),
          name: 'CESCO\nWater Stand-type Water Purifier',
          description: 'Ideal for multi-use facilities, this purifier offers extensive water purification capacity and substantial intake space.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/foodfactory/background_img_09.png'),
    products: [
      {
        posX: '57.5625rem',
        posY: '18.745rem',
        mobilePosX: '76%',
        mobilePosY: '55%',
        productInfo: {
          image: require('@/assets/images/location/foodfactory/product_img_08.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Food Manufacturing',
  meta: [
    {
      name: 'description',
      content: 'Food Manufacturing. Hygienically manage the food manufacturing process to safeguard against pests, viruses, and bacteria.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
